import { datadogRum } from '@datadog/browser-rum';
import { useCallback } from 'react';
import { EMBEDDED_APPRAISAL_FLOW_EXPERIMENT } from '~/constants/common/embeddedAppraisalFlow';
import { useTrackRenderedExperiment } from '~/context/common/AnalyticsProvider';
import { useIsNativeIOS } from '~/context/common/DeviceContext';
import {
  useIsLoggedIn,
  useIsUserStateLoaded
} from '~/context/common/UserContext';
import useExperimentBucket from '~/hooks/common/experiments/useExperimentBucket';

// Limits the A/B audience to signed-in shoppers who click an appraisal CTA (control included).
// Refresh clicks count too: Merch can't tell a mileage refresh from an edit, STC decides that.
export default function useTrackAppraisalCtaRendered(): () => void {
  const bucket = useExperimentBucket(EMBEDDED_APPRAISAL_FLOW_EXPERIMENT);
  const isLoggedIn = useIsLoggedIn();
  const isNativeIOS = useIsNativeIOS();
  const isUserStateLoaded = useIsUserStateLoaded();
  const trackRenderedExperiment = useTrackRenderedExperiment();

  const isTrackable =
    isUserStateLoaded && isLoggedIn && !isNativeIOS && Boolean(bucket);

  return useCallback(() => {
    if (!isTrackable) return;

    trackRenderedExperiment(EMBEDDED_APPRAISAL_FLOW_EXPERIMENT, bucket);
    datadogRum.addAction('experiment-rendered', {
      bucketKey: bucket,
      experimentKey: EMBEDDED_APPRAISAL_FLOW_EXPERIMENT
    });
  }, [bucket, isTrackable, trackRenderedExperiment]);
}
